export default __webpack_public_path__ + "static/media/visit_image_mobile.691c2622.png";